/**
 * Resolves a public asset path relative to the Vite base URL.
 * Use this instead of hardcoding absolute paths like "/IndustriesImages/..."
 * so that assets work correctly regardless of the deployment sub-path.
 *
 * @param {string} path - The asset path starting with "/"
 * @returns {string} The full path including the base URL prefix
 */
export function assetPath(path) {
  const base = import.meta.env.BASE_URL || "/";
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  
  // Normalize base to end with / and cleanPath to not start with /
  const normalizedBase = base.endsWith("/") ? base : `${base}/`;
  return `${normalizedBase}${cleanPath}`;
}
